import { SVGProps } from 'react';

const SatelliteDish = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m9 15 3-3m5 1a6 6 0 0 0-6-6m10 6A10 10 0 0 0 11 3m-7 7a7.31 7.31 0 0 0 10 10z"
    />
  </svg>
);
export default SatelliteDish;
